import { render, staticRenderFns } from "./PopupFormIframe.vue?vue&type=template&id=97808fc8&"
import script from "./PopupFormIframe.vue?vue&type=script&lang=ts&"
export * from "./PopupFormIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports